import { Form } from "@circle-react-uikit/Form";
import type { ItemProps } from "@circle-react-uikit/Form/Item";

interface FormItemProps extends ItemProps {
  appendTranslationRoot?: string;
  children?: React.ReactNode;
}

export const FormItem = ({
  appendTranslationRoot = "",
  children,
  ...props
}: FormItemProps) => (
  <Form.Item
    hideBorder
    fullWidth
    hideDescription
    translationRoot={
      appendTranslationRoot
        ? `live_streams.form.${appendTranslationRoot}`
        : "live_streams.form"
    }
    {...props}
  >
    {children}
  </Form.Item>
);
